// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__3i_bD"};